import { fetchWlsReceiptPdf } from './wls-api-client';

const downloadReceiptPdf = async (brand, bookingCode) => {
  const response = await fetchWlsReceiptPdf(brand, bookingCode);
  const { content_base64: contentBase64, filename } = response.data;
  const bytes = Uint8Array.from(atob(contentBase64), character =>
    character.charCodeAt(0)
  );
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 30000);
  }
};

export default downloadReceiptPdf;
